import React from 'react';

const formatNumber = (num) => {
  let NEWnum;
  switch (num) {
    case undefined:
      NEWnum = 0;
      break;
    case null:
      NEWnum = 0;
      break;
    case '':
      NEWnum = 0;
      break;
    default:
      NEWnum = num;
  }
  return NEWnum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const ActivityCenterComponent = (props) => {
  let goalDifferent = Math.floor(props.goal - props.total) > 0 ? Math.floor(props.goal - props.total) : 0;
  return (
    <div className='absolute flex flex-col items-center justify-center w-56 h-56 mt-4'>
      <div>
        <svg width='18' height='22' viewBox='0 0 18 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M15.6242 4.74285C12.6331 5.59551 12.0853 8.01366 12.2784 9.5498C10.1447 7.04161 10.2319 4.15622 10.2319 0C3.38815 2.5805 4.97955 10.0191 4.7749 12.2783C3.0539 10.869 2.72852 7.50339 2.72852 7.50339C0.911314 8.43859 0 10.9352 0 12.9604C0 17.8581 3.97 21.8281 8.86768 21.8281C13.7654 21.8281 17.7354 17.8581 17.7354 12.9604C17.7354 10.0498 15.5983 8.70737 15.6242 4.74285Z'
            fill='#EEAB45'
          />
        </svg>
      </div>
      <span className='text-3xl font-medium leading-relaxed text-summary-header'>{formatNumber(props.total)}</span>
      <span className='text-base text-secondary'>
        {props.t('kcal')}/{props.t('day')}
      </span>
      <span className='text-sm text-secondary'>
        {formatNumber(goalDifferent)} {props.t('kcal')}
      </span>
      <span className='text-sm text-secondary'>{props.t('reach_the_goal')}</span>
    </div>
  );
};

export default ActivityCenterComponent;
